<template>
  <GChart
    :settings="{ packages: ['corechart'] }"
    type="PieChart"
    :data="pieChartdata"
    :options="dynamicOptions"
	:events="chartEvents"
	ref = "gChart"
  />
</template>

<script>
import { GChart } from "vue-google-charts";

export default {
  components: { GChart },
  props: ["chartdata","chartcolumns","years","categ","subcateg","userColumnsData"],
  mounted() {
    $("#legendtitle").val(null); //no default value for legend title
  },
  data() {
    return {
      colsel: null,
      userColors: [
        "#FF6B6B", "#4ECDC4", "#45B7D1", "#96CEB4", "#FFEAA7",
        "#DDA0DD", "#98D8C8", "#F7DC6F", "#BB8FCE", "#85C1E9"
      ],
      options: {
        height: 500,
        colors: [
          "#cc9900",
          "#66cccc",
          "#cc66cc",
          "#003399",
          "#d16128",
          "#33cc33",
          "#6666cc",
          "#bc2626",
          "#339933",
          "#72530e",
        ],
        legend: { position: "top", maxLines: 5 }
      },
      chartEvents: {
        select: () => {
          const colchart = this.$refs.gChart.chartObject;
          const selection = colchart.getSelection();
          //console.log(selection[0]);
		  if (selection.length > 0) {
			const selectedRow = selection[0].row;
			const originalDataCount = this.chartdata.length;
			
			// Only trigger changeCol for original data, not user data
			if (selectedRow < originalDataCount) {
				this.colsel = this.chartcolumns[selectedRow];
				this.changeCol();
			}
			// If user data slice is clicked, do nothing
		  }

        },
      },
    };
  },
  methods: {
    runSerial(tasks) {
      var result = Promise.resolve();
      tasks.forEach((task) => {
        result = result.then(() => task());
      });
      return result;
    },
    changeCol() {
      let tasks = [
        () => {
          $("#categ1")
            .val(this.categ.id)
            .change();
        },
        () => {
          $("#categ2")
            .val(this.subcateg.id)
            .change();
        },
        () => {
          $("#year")
            .val(this.lastYear)
            .change();
        },
        () => {
          $("#categ3")
            .val(this.colsel)
            .change();
        },
        () => {
          this.$root.$emit("retract_panel");
        },
      ];

      this.runSerial(tasks);
    },
  },
  computed: {
    lastYear() {
      return this.years[this.years.length - 1];
    },
	dynamicOptions() {
		return Object.assign({}, this.options, {
			colors: this.chartColors
		});
	},
	chartColors() {
		return [...this.options.colors, ...this.userColors];
	},
	pieChartdata() {
      let data = [["Location", "Value"]];
      this.chartdata.forEach((d) => {
        data.push(d);
      });
	  // Add user data
	  if (this.userColumnsData && this.userColumnsData.length > 0) {
	    this.userColumnsData.forEach((userCol) => {
		  if (userCol.title.trim() !== '') {
		    const lastValue = userCol.data[userCol.data.length - 1];
		    data.push([userCol.title, parseFloat(lastValue) || 0]);
		  }
	    });
	  }
	  //console.log(this.chartdata);
      //console.log(data);
      return data;
    },
  },
};
</script>

<style>
</style>
